import { useState } from 'react'
import LoyaltyCard from './LoyaltyCard'
import EditLoyaltyCardModal from 'pages/Modals/EditLoyaltyCardModal'
import { Container, CardsGrid, InfoText  } from './styles'

export default function LoyaltyCardList ({
  cards = [],
  onEdit: handleEdit = () => null,
  onDelete: handleDelete = () => null
}) {
  const [cardData, setCardData] = useState (null)
  const [showEditCardModal, setShowEditCardModal] = useState (false)

  const editCard = card => {
    setCardData (card)
    toggleEditCardModal ()
  }

  const toggleEditCardModal = () => setShowEditCardModal (!showEditCardModal)

  if (cards.length === 0) return (
    <Container>
      <InfoText>Nenhum cartão fidelidade encontrado</InfoText>
    </Container>
  )

  return (
    <Container>
      <CardsGrid numCards={cards.length}>
        {cards.map ((card, index) => (
          <LoyaltyCard
            key={index}
            data={card}
            onEdit={editCard}
            onDelete={handleDelete}
          />
        ))}
      </CardsGrid>
      {!!cardData && (
        <EditLoyaltyCardModal
          visible={showEditCardModal}
          data={cardData}
          onClose={toggleEditCardModal}
          onConfirm={handleEdit}
        />
      )}
    </Container>
  )
}
